import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import register from './register.vue';
import forgot from './forgot.vue';
import { mapActions } from 'vuex';
import logoImg from '@/assets/images/logo-min.png';
import config from '@/config/index';
import { get_website_data } from "@/api/chuku";
import { loginMixins } from './loginMixins';
export default {
  name: 'LoginForm',
  mixins: [loginMixins],
  props: {},
  data: function data() {
    return {
      imgLogo: logoImg,
      passwordTypeIcon: 'ios-eye',
      passwordType: 'password',
      countriesData: [{
        id: 86,
        name: '+86'
      }, {
        id: '87',
        name: '+87'
      }],
      submitLoading: false,
      form: {
        userName: '',
        password: '',
        interest: true,
        countries: 86 //国别

      }
    };
  },
  computed: {
    rules: function rules() {
      return {
        userName: [{
          required: true,
          message: this.$t('loginArea.userNameNotNull'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('loginArea.passwordNotNull'),
          trigger: 'blur'
        }],
        interest: [{
          required: true,
          type: 'boolean',
          message: this.$t('loginArea.legalNoticeNotNull'),
          trigger: 'change'
        }]
      };
    },
    //法律法规
    getDocUrl: function getDocUrl() {
      var root = "";

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      var lan = localStorage.getItem('local');
      var doc;

      if (lan === 'zh-CN') {
        doc = "/static/yszc.html";
      } else {
        doc = "/static/yszc_en.html";
      }

      return root + doc;
    },
    //服务条款
    getDocServiceUrl: function getDocServiceUrl() {
      var root = "";

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      var lan = localStorage.getItem('local');
      var doc;

      if (lan === 'zh-CN') {
        doc = "/static/fwtk.html";
      } else {
        doc = "/static/fwtk_en.html";
      }

      return root + doc;
    }
  },
  components: {
    register: register
  },
  methods: _objectSpread({
    getAction: function getAction(type) {
      var url = "";

      if (type == 1) {
        url = "/static/yssm.html";
      } else {
        url = "/static/fwxy.html";
      }

      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + url;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + url;
      } else {
        result = config.baseUrl.alp + "" + url;
      }

      return result;
    }
  }, mapActions(['handleRegister', 'handleForgot']), {
    setLoading: function setLoading(b) {
      this.submitLoading = b;
    },
    //服务条款
    viewService: function viewService() {
      window.open(this.getDocServiceUrl);
    },
    //法律法规
    viewNotice: function viewNotice() {
      window.open(this.getDocUrl); //this.$emit('viewNotice')
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid) {
          _this.btnloading = true;

          _this.$emit('on-success-valid', {
            userName: _this.form.userName,
            password: _this.form.password
          });
        }
      });
    },
    // register(){
    //   const vm = this;
    //   let config = {
    //     loading:true,
    //     okText:"注册",
    //     render:(h)=>{
    //       return h("div",[
    //         h("h4",{
    //           style:{
    //             marginBottom:"15px"
    //           }
    //         },"用户注册"),
    //         h(register,{
    //           ref:"registerRef",
    //           props:{
    //             $store:this.$store
    //           }
    //         })
    //       ])
    //     },
    //     onOk:function () {
    //       this.buttonLoading = false;
    //       let reg = this.$refs.registerRef;
    //       let { mobile, code, password, org_code, email } = { ...reg.formData };//repeat_password
    //       let params = { mobile, code, password, org_code, email },
    //         callbak = res => {
    //           let msg = res.errorMsg;
    //         if(res.result === 0){
    //           this.$Message.success(msg);
    //           this.$Modal.remove();
    //         }else {
    //           this.$Message.error(msg);
    //         }
    //       };
    //       let submit = function (){
    //         vm.handleRegister(params).then(res=>{
    //           callbak(res);
    //         });
    //       };
    //       this.$refs.registerRef.handleSubmit(submit);
    //     }
    //   };
    //   this.$Modal.confirm(config);
    // },
    // forgotPassword(){
    //   const vm = this;
    //   let config = {
    //     loading:true,
    //     //okText:"注册",
    //     render:(h)=>{
    //       return h("div",[
    //         h("h4",{
    //           style:{
    //             marginBottom:"15px"
    //           }
    //         },"找回密码"),
    //         h(forgot,{
    //           ref:"forgotRef",
    //           props:{
    //             $store:this.$store
    //           }
    //         })
    //       ])
    //     },
    //     onOk:function () {
    //       this.buttonLoading = false;
    //       let reg = this.$refs.forgotRef;
    //       let { mobile, code, password, org_code } = { ...reg.formMoblie };
    //       let emailData = reg.formEmail,nameType,sendtype;
    //       let params,
    //         callbak = res => {
    //           let msg = res.errorMsg;
    //           if(res.result === 0){
    //             this.$Message.success(`重置密码${msg},请登录`);
    //             this.$Modal.remove();
    //           }else {
    //             this.$Message.error(msg);
    //           }
    //         };
    //       if(reg.nameTabs == "name1"){
    //         sendtype = 1;
    //         params = {mobile, code, password, sendtype};
    //         nameType = "formMoblie";
    //       }else {
    //         sendtype = 2;
    //         params = {
    //           email:emailData.email,
    //           code:emailData.code,
    //           password:emailData.password,
    //           sendtype
    //         };
    //         nameType = "formEmail";
    //       }
    //       let submit = function (){
    //         vm.handleForgot(params).then(res=>{
    //           callbak(res);
    //         });
    //       };
    //       this.$refs.forgotRef.handleSubmit(nameType,submit);
    //     }
    //   };
    //   this.$Modal.confirm(config);
    // },
    //显示与隐藏密码
    swicthPassword: function swicthPassword() {
      if (this.passwordTypeIcon === 'ios-eye') {
        this.passwordTypeIcon = 'ios-eye-off';
        this.passwordType = 'text';
      } else if (this.passwordTypeIcon === 'ios-eye-off') {
        this.passwordTypeIcon = 'ios-eye';
        this.passwordType = 'password';
      }
    }
  }),
  created: function created() {
    var _this2 = this;

    get_website_data().then(function (res) {
      _this2.imgLogo = "".concat(process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp).concat(res.body.logo_url);
    });
  }
};